export const PERSONAL_LOAN_PREQUAL_SELECTED = 'PERSONAL_LOAN_PREQUAL_SELECTED';
export const AUTO_LOAN_FORM_COMPLETED = 'AUTO_LOAN_FORM_COMPLETED';
